import type { LexicalEditor } from "lexical";
import type { ColumnResizeGuide } from "./types";

export function buildColumnResizeGuides(editor: LexicalEditor, hoverTableKey: string | null): ColumnResizeGuide[] {
  const out: ColumnResizeGuide[] = [];
  if (!hoverTableKey) return out;
  const rootEl = editor.getElementByKey(hoverTableKey);
  const tableDom =
    rootEl instanceof HTMLTableElement
      ? rootEl
      : (rootEl?.querySelector("table") as HTMLTableElement | null);
  if (!tableDom) return out;
  const allRows = tableDom.querySelectorAll("tr");
  if (allRows.length === 0) return out;
  const firstRowRect = allRows[0].getBoundingClientRect();
  const lastRowRect = allRows[allRows.length - 1].getBoundingClientRect();
  const bandTop = firstRowRect.top;
  const bandHeight = Math.max(0, lastRowRect.bottom - bandTop);
  const firstRow = allRows[0];
  const cells = firstRow.querySelectorAll("th, td");
  cells.forEach((td, idx) => {
    const r = td.getBoundingClientRect();
    out.push({
      centerX: r.right,
      top: bandTop,
      height: bandHeight,
      colIndex: idx,
      tableKey: hoverTableKey,
    });
  });
  return out;
}
